import {
    Locale,
    ViewModel,
    Country,
    RequestOrganizationViewModel,
    VerificationResponse,
    assertValidLocale,
    getOptions,
    DEFAULT_LOCALE,
    getSafe,
} from '@sheerid/jslib';

import { getQueryParamsFromUrl } from '../utils/browser';

/**
 * @todo tests
 * @private
 */
export const countryToLocale = (country: Country): Locale => {
    let locale: Locale;
    switch (country) {
        case 'US':
            locale = 'en-US';
            break;
        default:
            locale = 'en-US';
    }
    return locale;
};


/**
 * @description Retrieves the locale used to display the verification form. It will attempt to bring the best default by looking at these places:
 * - Retrieve from previous user selection in ChangeLocaleComponent
 * - Retrieve based on the country selected
 * - Retrieve from Options
 * - Retrieve from the URL
 * - Retrieve from the VerificationResponse
 * - Retrieve library DEFAULT_LOCALE
 * If found a locale but is not supported by the library, it'll return DEFAULT_LOCALE instead.
 */
export const getLocaleSafely = (viewModel?: ViewModel | RequestOrganizationViewModel, verificationResponse?: VerificationResponse): Locale => {

    function getLocaleFromViewModel(viewModel: ViewModel | RequestOrganizationViewModel): Locale | undefined {
        return getSafe(() => viewModel.localeChoice.value);
    }

    function getLocaleFromCountrySelection(viewModel: ViewModel | RequestOrganizationViewModel): Locale | undefined {
        const country: Country = getSafe(() => viewModel.countryChoice.value);

        return country ? countryToLocale(country) : undefined;
    }

    function getLocaleFromUrl(): Locale | undefined {
        const queryParamLocale = getQueryParamsFromUrl(window.location.href).get('locale') as Locale;

        return queryParamLocale ? queryParamLocale : undefined;
    }

    function getLocaleFromVerificationResponse(verificationResponse: VerificationResponse) {
        return getSafe(() => verificationResponse.locale);
    }

    const locale: Locale = getLocaleFromViewModel(viewModel) ||
        getLocaleFromCountrySelection(viewModel) ||
        getOptions().locale ||
        getLocaleFromUrl() ||
        getLocaleFromVerificationResponse(verificationResponse) ||
        DEFAULT_LOCALE;

    try {
        assertValidLocale(locale);

        return locale;
    } catch (error) {
        return DEFAULT_LOCALE;
    }
};
